module.exports = __webpack_public_path__ + "static/media/wendy_cabrera_rubio_12.adce8528.jpg";